import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from "react-router-dom";
import {ThemeContext, WhiteLabelContext} from "ToolboxUtils/web/context/context";
import isMobileView from "ToolboxUtils/web/is-mobile-view";
import PropTypes from 'prop-types';
import { DesireWrapper } from './desire-homepage-product-card.styles';
import ImageResize from 'ToolboxComponents/utils/images/image-resize/image-resize';

const DesireHomepageSlider = props => {
  const history = useHistory();
  const theme = useContext(ThemeContext).state;
  const whiteLabel = useContext(WhiteLabelContext).state;

  const [isMobile, setIsMobile] = useState(null);
  useEffect(() => {
    setIsMobile(isMobileView());
  }, [isMobile]);

  return (
    <DesireWrapper theme={theme} isMobile={isMobile}>
      <button type="button"
        onClick={() => {
          // redirection de l'envie balades vers loopi pour vals de saintonge
          if ( (whiteLabel.id === 10)  && props.desire.id === 6) {
            window.location.href = 'https://infiniment-charentes.loopi-velo.fr/';
          } else if (whiteLabel.id === 8 && props.desire.id === 52) {
            history.push("/catalogue/envie/jop");
          } else {
            props.setDesireSelected(props.desire.id); props.onClick && props.onClick()
          }
        }}
        className={'btn-search' + (props.desire.id === props.desireSelected ? ' active' : '')}
      >
        <React.Fragment>
          <ImageResize
            src={props.desire.picture}
          />
          {/* <img src={process.env.CONFIG.DESIRES_URL + props.desire.picture} alt=""  /> */}
          <span className="search-form-label">{props.desire.name}</span>
        </React.Fragment>
      </button>
    </DesireWrapper>
  );
};

DesireHomepageSlider.propTypes = {
  desire: PropTypes.object.isRequired,
};

export default DesireHomepageSlider;
